import {SelectItem} from '@/components/ui/select-atoms/SelectAtoms'
import styled, {css} from 'styled-components'

export const StyledInputTimeSelectItem = styled(SelectItem)<{$isWarning?: boolean}>(
    ({theme: {palette}, $isWarning}) => css`
        ${$isWarning &&
        css`
            color: ${palette.warning[700]};
        `}
    `
)
